export default "__VITE_ASSET___StHAf_4__"